/**
 * Navigation menu controller. The header's [data-nav-toggle] button opens and
 * closes a full-screen panel by toggling `nav-menu-open` on <html> (the panel
 * slide + overlay fade are pure CSS in critical.css). Closes on overlay click,
 * Escape, and when a reservation trigger inside the menu is clicked (the
 * reservation modal then takes over). Nav links are real links, so navigating
 * reloads the page and resets the menu.
 */
(function () {
  var OPEN_CLASS = 'nav-menu-open';

  var root = document.querySelector('[data-nav-root]');
  var toggle = document.querySelector('[data-nav-toggle]');
  if (!root || !toggle) return;

  var html = document.documentElement;
  var overlay = root.querySelector('.nav-menu-overlay');
  var panels = root.querySelectorAll('.nav-menu-left, .nav-menu');
  var layers = window.BaldiLayers;

  function isOpen() {
    return html.classList.contains(OPEN_CLASS);
  }

  function setOpen(open) {
    html.classList.toggle(OPEN_CLASS, open);
    if (layers) {
      if (open) layers.lock('nav-menu');
      else layers.unlock('nav-menu');
    }
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    for (var i = 0; i < panels.length; i++) {
      panels[i].setAttribute('aria-hidden', open ? 'false' : 'true');
    }
    if (overlay) overlay.tabIndex = open ? 0 : -1;
  }

  toggle.addEventListener('click', function () {
    setOpen(!isOpen());
  });

  if (overlay) {
    overlay.addEventListener('click', function () {
      setOpen(false);
    });
  }

  // Opening the reservation modal from inside the menu should close the menu.
  var reservationTriggers = root.querySelectorAll('[data-reservation-open]');
  for (var j = 0; j < reservationTriggers.length; j++) {
    reservationTriggers[j].addEventListener('click', function () {
      setOpen(false);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) setOpen(false);
  });

  document.addEventListener('baldi:nav:close', function () {
    setOpen(false);
  });
})();
